import { AfterViewInit, Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';
import * as echarts from 'echarts';
import {
    Social_Platform,
    Material_Design_Red,
    Material_Design_Pink,
    Material_Design_Purple,
    Material_Design_Deep_Purple,
    Material_Design_Lime,
    Classic_20
} from '../config/color-palettes';

import { MapService } from './map.service';

// import * as dmas from '../../../assets/data/dma-shapes.json';
// import * as dma_props from '../../../assets/data/dma-properties.json';

@Component({
    selector: 'nbx-map-echart',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})

export class MapComponent implements AfterViewInit, OnChanges {

    constructor(private mapService: MapService) { }

    @Input() resizable: boolean = true;
    autoResize = true;

    width: number;
    height: number;
    defaultThemeVariables = defaultTheme.variables;
    @Input() type: string = 'dmas';
    @Input() visualmapstr: string = '';
    @Input() seriesstr: string = '';
    @Input() titlestr: string = '';
    @Input() tooltipstr: string = '';
    @Input() gridstr: string = '';

    options: any = {};
    title: any;
    tooltip: any;
    visualMap: any;
    series: any;
    grid: any;
    map: any;
    dmas: any;
    hhtv_population: any = [];
    mapSubscribe: any;
    propsSubscribe: any;

    echartsInstance: any;

    onResized(event: ResizedEvent) {
        this.width = event.newWidth;
        this.height = event.newHeight;

        if (this.echartsInstance) {
            this.echartsInstance.resize({
                height: event.newHeight
            });
        }
    }

    onChartInit(e: any) {
        this.echartsInstance = e;
    }

    ngAfterViewInit() {
        // this.mapSubscribe = this.mapService.getJson(this.type)
        // .subscribe(dmas => {
        var dmas = this.mapService.getJson(this.type);
        var features = dmas.features;

        // this.propsSubscribe = this.mapService.getProperties(this.type)
        //     .subscribe(dma_props => {
        var dma_props = this.mapService.getProperties(this.type);

        features.forEach(element => {
            var val = ''
            var hhtv_val = dma_props[element.properties.dma_code]
            if (hhtv_val) {
                val = hhtv_val["TV Homes"]
            }

            this.hhtv_population.push({ name: element.properties.name, value: val })
        });

        this.tooltip = (this.tooltipstr == '') ? {
            trigger: 'item',
            transitionDuration: 0.2,
            formatter: function (params) {
                var value = (params.value + '').split('.');
                var val;
                val = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,');
                return '<b>' + params.seriesName + '</b>' + '<br/>' + params.name + ': ' + val;
            }
        } : JSON.parse(this.tooltipstr);

        this.title = (this.titlestr == '') ? {
            text: 'USA TV Population Estimates (DMAs)',
            subtext: 'Nielsen Data',
            left: 'center'
        } : JSON.parse(this.titlestr);

        this.visualMap = (this.visualmapstr == '') ? {
            left: 'right',
            min: 3000,
            max: 10000000,
            inRange: {
                color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
            },
            text: ['High', 'Low'],           // 文本，默认为数值文本
            calculable: true
        } : JSON.parse(this.visualmapstr);

        this.grid = (this.gridstr == '') ? {
            left: '0%',
            right: '0%',
            bottom: '3%',
            containLabel: true,
        } : JSON.parse(this.gridstr);

        this.series = (this.seriesstr == '') ? [
            {
                name: 'USA TV Population Estimates',
                type: 'map',
                roam: true,
                map: this.type,
                emphasis: {
                    label: {
                        show: true
                    }
                },
                // nameProperty: 'dma_name',
                data: this.hhtv_population
            }
        ] : JSON.parse(this.seriesstr);

        this.options = {
            backgroundColor: 'transparent',
            color: Object.values(Classic_20),
            tooltip: this.tooltip,
            grid: this.grid,
            title: this.title,
            visualMap: this.visualMap,
            series: this.series
        };

        // console.log(this.options)
        // })
        // });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                switch (propName) {
                    case 'visualmapstr': {
                        console.log("visual map update");
                        this.updateOptions('visualMap', this.visualmapstr);
                        break;
                    }
                    case 'seriesstr': {
                        console.log("series update");
                        this.updateOptions('series', this.seriesstr);
                        break;
                    }
                    case 'titlestr': {
                        console.log("title update");
                        this.updateOptions('title', this.titlestr);
                        break;
                    }
                    case 'gridstr': {
                        console.log("grid update");
                        this.updateOptions('grid', this.gridstr);
                        break;
                    }
                }
            }
        }

        this.options = {
            backgroundColor: 'transparent',
            color: Object.values(Classic_20),
            title: this.title,
            tooltip: this.tooltip,
            grid: this.grid,
            visualMap: this.visualMap,
            series: this.series
        };
    }

    private updateOptions(opt, value) {
        // console.log(opt)
        // console.log(value)
        this[opt] = JSON.parse(value);
        // console.log(this[opt]);

        this.options[opt] = this[opt];

        // console.log(this.options);
    }

}